import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';
import { PostStatus, type Post } from '@src/store/contentEntities/model';
import { getPost, setPost } from './posts';

export interface ApprovePostApiRequestPayload {
    userId: string; // moderator id
    postId: string;
    approve: boolean;
}

export const approvePost = async (payload: ApprovePostApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Post>>(
        '/post/approve',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false,
    );
    const post = data.payload ? data.payload : ({ ...getPost(payload.postId), status: PostStatus.DELETED_BY_TOKEN_ADMIN } as Post);

    setPost(post);

    return post;
};
